// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;charset=UTF-8,%3Csvg xmlns%3D%22http%3A//www.w3.org/2000/svg%22 width%3D%2224%22 height%3D%2224%22 viewBox%3D%220 0 24 24%22 focusable%3D%22false%22 aria-hidden%3D%22true%22 data-testid%3D%22ArrowRightIcon%22%3E%3Cpath d%3D%22m10 17 5-5-5-5z%22/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Texts and Headings */
div.dotcom-expert-bio-textblock * {
	color: #000000 !important;
	background-color: #FFFFFF !important;
	font-size: 12px !important;
}

div.dotcom-expert-bio-textblock strong, div.dotcom-expert-bio-textblock b, 
div.dotcom-expert-bio-textblock h2, div.dotcom-expert-bio-textblock h3 {
  font-weight: 'normal';
}

div.dotcom-expert-bio-textblock p, div.dotcom-expert-bio-textblock h1, div.dotcom-expert-bio-textblock h2,
div.dotcom-expert-bio-textblock h3, div.dotcom-expert-bio-textblock h4, div.dotcom-expert-bio-textblock h5,
div.dotcom-expert-bio-textblock h6 {
  margin-bottom: 0.75rem;
}

div.dotcom-expert-bio-textblock h1 {
    font-size: 12px;
    font-weight: 'normal';;
}
div.dotcom-expert-bio-textblock h2 {
    font-size: 12px;
    font-weight: 'normal';;
}

div.dotcom-expert-bio-textblock h4 {
    font-size: 12px;
    font-weight: 'normal';
}

div.dotcom-expert-bio-textblock h5 {
    font-size: 12px;
    font-weight: 'normal';
}

div.dotcom-expert-bio-textblock h6 {
    font-size: 12px;
    font-weight: 'normal';
}

div.dotcom-expert-bio-textblock p span.intro-text {
  font-size: 12px;
  font-weight: 'normal';
}
/* Texts and Headings */

/* Lists */
div.dotcom-expert-bio-textblock ul.list--style-a {
	position: relative;
	list-style: none;
	margin: 0
}

div.dotcom-expert-bio-textblock .list--style-a:before {
	position: absolute;
	top: 50%;
	-webkit-transform: translateY(-50%);
	-ms-transform: translateY(-50%);
	transform: translateY(-50%);
	left: 0;
	content: '\\e90e';
	font-family: cr-web;
	color: #000000;
	font-size: 12px
}

div.dotcom-expert-bio-textblock .list--style-a li, div.dotcom-expert-bio-textblock .list--style-b li {
	float: left;
	color: #000000;
	font-size: 12px;
	line-height: 1.2
}

div.dotcom-expert-bio-textblock .list--style-a li {
	display: block;
	margin-left: .0625rem
}

div.dotcom-expert-bio-textblock .list--style-a li:after {
	content: '|';
	margin-left: .125rem
}

div.dotcom-expert-bio-textblock .list--style-a li:last-child:after {
	display: none
}

div.dotcom-expert-bio-textblock ul.list--style-b {
	list-style: none;
	margin: 0
}

div.dotcom-expert-bio-textblock .list--style-b li {
	display: block;
	font-weight: 'normal';
	margin-right: .1875rem
}

@media (max-width:767px) {
	div.dotcom-expert-bio-textblock .list--style-b li {
		margin-bottom: .375rem
	}
}

div.dotcom-expert-bio-textblock .list--style-b li:after {
	content: '|';
	margin-left: .1875rem
}

div.dotcom-expert-bio-textblock .list--style-b li:last-child:after {
	display: none
}

div.dotcom-expert-bio-textblock ul.list--style-c {
	list-style: none;
	margin: 0
}

div.dotcom-expert-bio-textblock .list--style-c li {
	font-size: 12px;
	color: #000;
    display: table;
}

div.dotcom-expert-bio-textblock .list--style-c li:before {
    content: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    font-size: 12px;
    margin-right: .625rem;
	vertical-align: middle;
}

div.dotcom-expert-bio-textblock ul.list--style-d {
	list-style: none;
	margin: 0;
}

div.dotcom-expert-bio-textblock .list--style-d li {
	font-size: 12px;
	position: relative;
	display: block;
}

div.dotcom-expert-bio-textblock .list--style-d li:before {
	content: '';
	background-image: url(https:www.controlrisks.com/_images/chevrons/chevron-aqua.svg);
	display: block;
	background-size: 19px 19px;
	height: 19px;
	width: 19px;
	margin: 4px 5px 0 0;
	float: left;
}

/* Lists */

div.dotcom-expert-bio-textblock table[align="center"] {
	display: flex;
	justify-content: center;
}`, "",{"version":3,"sources":["webpack://./src/dotcom-expert-bio-style.css"],"names":[],"mappings":"AAAA,uBAAuB;AACvB;CACC,yBAAyB;CACzB,oCAAoC;CACpC,0BAA0B;AAC3B;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;;;EAGE,sBAAsB;AACxB;;AAEA;IACI,eAAe;IACf,qBAAqB;AACzB;AACA;IACI,eAAe;IACf,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,qBAAqB;AACzB;;AAEA;EACE,eAAe;EACf,qBAAqB;AACvB;AACA,uBAAuB;;AAEvB,UAAU;AACV;CACC,kBAAkB;CAClB,gBAAgB;CAChB;AACD;;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,mCAAmC;CACnC,+BAA+B;CAC/B,2BAA2B;CAC3B,OAAO;CACP,gBAAgB;CAChB,mBAAmB;CACnB,cAAc;CACd;AACD;;AAEA;CACC,WAAW;CACX,cAAc;CACd,eAAe;CACf;AACD;;AAEA;CACC,cAAc;CACd;AACD;;AAEA;CACC,YAAY;CACZ;AACD;;AAEA;CACC;AACD;;AAEA;CACC,gBAAgB;CAChB;AACD;;AAEA;CACC,cAAc;CACd,qBAAqB;CACrB;AACD;;AAEA;CACC;EACC;CACD;AACD;;AAEA;CACC,YAAY;CACZ;AACD;;AAEA;CACC;AACD;;AAEA;CACC,gBAAgB;CAChB;AACD;;AAEA;CACC,eAAe;CACf,WAAW;IACR,cAAc;AAClB;;AAEA;IACI,gDAAqS;IACrS,eAAe;IACf,qBAAqB;CACxB,sBAAsB;AACvB;;AAEA;CACC,gBAAgB;CAChB,SAAS;AACV;;AAEA;CACC,eAAe;CACf,kBAAkB;CAClB,cAAc;AACf;;AAEA;CACC,WAAW;CACX,mFAAmF;CACnF,cAAc;CACd,0BAA0B;CAC1B,YAAY;CACZ,WAAW;CACX,mBAAmB;CACnB,WAAW;AACZ;;AAEA,UAAU;;AAEV;CACC,aAAa;CACb,uBAAuB;AACxB","sourcesContent":["/* Texts and Headings */\r\ndiv.dotcom-expert-bio-textblock * {\r\n\tcolor: #000000 !important;\r\n\tbackground-color: #FFFFFF !important;\r\n\tfont-size: 12px !important;\r\n}\r\n\r\ndiv.dotcom-expert-bio-textblock strong, div.dotcom-expert-bio-textblock b, \r\ndiv.dotcom-expert-bio-textblock h2, div.dotcom-expert-bio-textblock h3 {\r\n  font-weight: 'normal';\r\n}\r\n\r\ndiv.dotcom-expert-bio-textblock p, div.dotcom-expert-bio-textblock h1, div.dotcom-expert-bio-textblock h2,\r\ndiv.dotcom-expert-bio-textblock h3, div.dotcom-expert-bio-textblock h4, div.dotcom-expert-bio-textblock h5,\r\ndiv.dotcom-expert-bio-textblock h6 {\r\n  margin-bottom: 0.75rem;\r\n}\r\n\r\ndiv.dotcom-expert-bio-textblock h1 {\r\n    font-size: 12px;\r\n    font-weight: 'normal';;\r\n}\r\ndiv.dotcom-expert-bio-textblock h2 {\r\n    font-size: 12px;\r\n    font-weight: 'normal';;\r\n}\r\n\r\ndiv.dotcom-expert-bio-textblock h4 {\r\n    font-size: 12px;\r\n    font-weight: 'normal';\r\n}\r\n\r\ndiv.dotcom-expert-bio-textblock h5 {\r\n    font-size: 12px;\r\n    font-weight: 'normal';\r\n}\r\n\r\ndiv.dotcom-expert-bio-textblock h6 {\r\n    font-size: 12px;\r\n    font-weight: 'normal';\r\n}\r\n\r\ndiv.dotcom-expert-bio-textblock p span.intro-text {\r\n  font-size: 12px;\r\n  font-weight: 'normal';\r\n}\r\n/* Texts and Headings */\r\n\r\n/* Lists */\r\ndiv.dotcom-expert-bio-textblock ul.list--style-a {\r\n\tposition: relative;\r\n\tlist-style: none;\r\n\tmargin: 0\r\n}\r\n\r\ndiv.dotcom-expert-bio-textblock .list--style-a:before {\r\n\tposition: absolute;\r\n\ttop: 50%;\r\n\t-webkit-transform: translateY(-50%);\r\n\t-ms-transform: translateY(-50%);\r\n\ttransform: translateY(-50%);\r\n\tleft: 0;\r\n\tcontent: '\\e90e';\r\n\tfont-family: cr-web;\r\n\tcolor: #000000;\r\n\tfont-size: 12px\r\n}\r\n\r\ndiv.dotcom-expert-bio-textblock .list--style-a li, div.dotcom-expert-bio-textblock .list--style-b li {\r\n\tfloat: left;\r\n\tcolor: #000000;\r\n\tfont-size: 12px;\r\n\tline-height: 1.2\r\n}\r\n\r\ndiv.dotcom-expert-bio-textblock .list--style-a li {\r\n\tdisplay: block;\r\n\tmargin-left: .0625rem\r\n}\r\n\r\ndiv.dotcom-expert-bio-textblock .list--style-a li:after {\r\n\tcontent: '|';\r\n\tmargin-left: .125rem\r\n}\r\n\r\ndiv.dotcom-expert-bio-textblock .list--style-a li:last-child:after {\r\n\tdisplay: none\r\n}\r\n\r\ndiv.dotcom-expert-bio-textblock ul.list--style-b {\r\n\tlist-style: none;\r\n\tmargin: 0\r\n}\r\n\r\ndiv.dotcom-expert-bio-textblock .list--style-b li {\r\n\tdisplay: block;\r\n\tfont-weight: 'normal';\r\n\tmargin-right: .1875rem\r\n}\r\n\r\n@media (max-width:767px) {\r\n\tdiv.dotcom-expert-bio-textblock .list--style-b li {\r\n\t\tmargin-bottom: .375rem\r\n\t}\r\n}\r\n\r\ndiv.dotcom-expert-bio-textblock .list--style-b li:after {\r\n\tcontent: '|';\r\n\tmargin-left: .1875rem\r\n}\r\n\r\ndiv.dotcom-expert-bio-textblock .list--style-b li:last-child:after {\r\n\tdisplay: none\r\n}\r\n\r\ndiv.dotcom-expert-bio-textblock ul.list--style-c {\r\n\tlist-style: none;\r\n\tmargin: 0\r\n}\r\n\r\ndiv.dotcom-expert-bio-textblock .list--style-c li {\r\n\tfont-size: 12px;\r\n\tcolor: #000;\r\n    display: table;\r\n}\r\n\r\ndiv.dotcom-expert-bio-textblock .list--style-c li:before {\r\n    content: url('data:image/svg+xml;charset=UTF-8,%3Csvg xmlns%3D%22http%3A//www.w3.org/2000/svg%22 width%3D%2224%22 height%3D%2224%22 viewBox%3D%220 0 24 24%22 focusable%3D%22false%22 aria-hidden%3D%22true%22 data-testid%3D%22ArrowRightIcon%22%3E%3Cpath d%3D%22m10 17 5-5-5-5z%22/%3E%3C/svg%3E');\r\n    font-size: 12px;\r\n    margin-right: .625rem;\r\n\tvertical-align: middle;\r\n}\r\n\r\ndiv.dotcom-expert-bio-textblock ul.list--style-d {\r\n\tlist-style: none;\r\n\tmargin: 0;\r\n}\r\n\r\ndiv.dotcom-expert-bio-textblock .list--style-d li {\r\n\tfont-size: 12px;\r\n\tposition: relative;\r\n\tdisplay: block;\r\n}\r\n\r\ndiv.dotcom-expert-bio-textblock .list--style-d li:before {\r\n\tcontent: '';\r\n\tbackground-image: url(https:www.controlrisks.com/_images/chevrons/chevron-aqua.svg);\r\n\tdisplay: block;\r\n\tbackground-size: 19px 19px;\r\n\theight: 19px;\r\n\twidth: 19px;\r\n\tmargin: 4px 5px 0 0;\r\n\tfloat: left;\r\n}\r\n\r\n/* Lists */\r\n\r\ndiv.dotcom-expert-bio-textblock table[align=\"center\"] {\r\n\tdisplay: flex;\r\n\tjustify-content: center;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
